<div class="container-fluid">
    <div class="row">

        <div class="card shadow-sm p-0">
            <div class="card-header">
                <h3 class="card-title">{{ pageTitle }}</h3>
            </div>
            <div class="card-body">
                <risk-time-frame-form
                    [riskTimeFrame]="riskTimeFrame"
                    (onSavedData)="onSavedData($event)" />
            </div>
        </div>
    </div>
</div>
